import React, { lazy } from 'react';
import { Button } from './Button';
import { Check, Shield, Clock, Gift } from 'lucide-react';
const BONUSES = [{
  title: 'Chef Peludo',
  price: 'USD 9',
  image: 'https://cdn.magicpatterns.com/uploads/21ZVwKxWDepopxGozfBEZf/Bono_1.jpg'
}, {
  title: 'Botiquín de Emergencia',
  price: 'USD 5',
  image: 'https://cdn.magicpatterns.com/uploads/piJPcCyqFRkA12SheB1S6H/Bono_2.jpg'
}, {
  title: 'Paz en la Manada',
  price: 'USD 13',
  image: 'https://cdn.magicpatterns.com/uploads/uSRCUqbeo23euUtVQjGxHA/Bono_3.jpg'
}, {
  title: 'El Código de Obediencia',
  price: 'USD 4',
  image: 'https://cdn.magicpatterns.com/uploads/dcvFj7xFprwBmzAUPtXpVM/Bono_4.jpg'
}, {
  title: 'Farmacia Natural',
  price: 'USD 6',
  image: 'https://cdn.magicpatterns.com/uploads/5P3qk5rs3LczYFqnhU7nbM/Bono_5.jpg'
}];
export function Pricing() {
  return <section className="py-24 bg-white relative" data-id="element-125">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-126">
        <div className="bg-white rounded-[2.5rem] shadow-2xl border border-sage-light/30 overflow-hidden relative" data-id="element-127">
          {/* Top Banner */}
          <div className="bg-terracotta text-white text-center py-3 font-medium text-sm tracking-wide uppercase flex items-center justify-center" data-id="element-128">
            <Clock className="w-4 h-4 mr-2" data-id="element-129" />
            Oferta por tiempo limitado
          </div>

          <div className="p-8 md:p-12" data-id="element-130">
            <div className="text-center mb-10" data-id="element-131">
              <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-132">
                El Método Maestro de Bio-Nutrición
              </h2>
              <p className="text-gray-600" data-id="element-133">
                Acceso inmediato de por vida + Todos los bonos
              </p>
            </div>

            <div className="flex flex-col md:flex-row items-center justify-center gap-8 mb-10" data-id="element-134">
              <div className="text-center md:text-right" data-id="element-135">
                <p className="text-gray-400 text-lg line-through decoration-red-500 decoration-2" data-id="element-136">
                  Valor Total: USD 57
                </p>
                <p className="text-sm text-gray-500 mt-1" data-id="element-137">Precio regular</p>
              </div>
              <div className="hidden md:block w-px h-16 bg-gray-200" data-id="element-138"></div>
              <div className="text-center md:text-left relative" data-id="element-139">
                <span className="absolute -top-4 -right-2 md:-right-6 bg-terracotta text-white text-xs font-bold uppercase tracking-wider px-3 py-1 rounded-full shadow-lg transform rotate-6" data-id="element-140">
                  -89% OFF
                </span>
                <div className="flex items-start justify-center md:justify-start text-terracotta" data-id="element-141">
                  <span className="text-xl font-bold mt-3 mr-2" data-id="element-142">USD</span>
                  <span className="text-6xl font-bold tracking-tighter" data-id="element-143">
                    6,39
                  </span>
                </div>
                <p className="text-sm font-bold text-sage-dark uppercase tracking-wider mt-1" data-id="element-144">
                  Pago Único • Ahorras USD 50,61
                </p>
              </div>
            </div>

            <div className="bg-cream-light rounded-2xl p-6 mb-10" data-id="element-145">
              <h4 className="font-bold text-gray-900 mb-4 text-center" data-id="element-146">
                Lo que obtienes hoy:
              </h4>
              <div className="grid md:grid-cols-2 gap-4" data-id="element-147">
                {["El Libro Digital 'Más Años Juntos'", 'Acceso de por vida', 'Actualizaciones gratuitas'].map((item, i) => <div key={i} className="flex items-center" data-id="element-148">
                    <div className="w-5 h-5 rounded-full bg-sage flex items-center justify-center mr-3 shrink-0" data-id="element-149">
                      <Check className="w-3 h-3 text-white" data-id="element-150" />
                    </div>
                    <span className="text-gray-700 text-sm" data-id="element-151">{item}</span>
                  </div>)}
              </div>
            </div>

            {/* Bonus recap with strikethrough prices */}
            <div className="bg-gradient-to-br from-sage-light/20 to-cream-dark/30 rounded-2xl p-6 mb-8 border border-sage-light/40" data-id="element-152">
              <div className="flex items-center justify-center mb-4" data-id="element-153">
                <Gift className="w-5 h-5 text-terracotta mr-2" data-id="element-154" />
                <h4 className="font-serif font-bold text-gray-900 text-lg" data-id="element-155">
                  + 5 Bonos exclusivos hoy{' '}
                  <span className="text-terracotta" data-id="element-156">GRATIS</span>
                </h4>
              </div>
              <ul className="space-y-3" data-id="element-157">
                {BONUSES.map((bonus, i) => <li key={i} className="flex items-center justify-between gap-3 text-sm md:text-base bg-white/60 rounded-2xl p-2 pr-3 border border-sage-light/30" data-id="element-158">
                    <div className="flex items-center min-w-0 gap-3 flex-1" data-id="element-159">
                      <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl overflow-hidden shrink-0 border border-sage-light/50 shadow-sm bg-cream-light" data-id="element-160">
                        <img src={bonus.image} alt={bonus.title} width={56} height={56} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-161" />
                      </div>
                      <div className="flex items-start min-w-0 flex-1" data-id="element-162">
                        <div className="w-5 h-5 rounded-full bg-sage flex items-center justify-center mr-2 shrink-0 mt-0.5" data-id="element-163">
                          <Check className="w-3 h-3 text-white" data-id="element-164" />
                        </div>
                        <span className="text-gray-800 font-medium leading-snug break-words" data-id="element-165">
                          {bonus.title}
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-col sm:flex-row items-end sm:items-center gap-1 sm:gap-2 shrink-0" data-id="element-166">
                      <span className="text-gray-400 line-through decoration-red-400 text-xs sm:text-sm" data-id="element-167">
                        {bonus.price}
                      </span>
                      <span className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-terracotta bg-terracotta/10 px-2 py-0.5 rounded-full" data-id="element-168">
                        Gratis
                      </span>
                    </div>
                  </li>)}
              </ul>
              <div className="mt-4 pt-4 border-t border-sage-light/40 flex justify-between items-center" data-id="element-169">
                <span className="text-sm font-bold text-gray-700 uppercase tracking-wider" data-id="element-170">
                  Valor total bonos
                </span>
                <span className="text-sage-dark font-serif font-bold text-lg" data-id="element-171">
                  <span className="line-through decoration-red-400 mr-2" data-id="element-172">
                    USD 37
                  </span>
                  <span className="text-terracotta" data-id="element-173">Incluido</span>
                </span>
              </div>
            </div>

            <div className="text-center" data-id="element-174">
              <Button size="lg" fullWidth href="https://pay.hotmart.com/I106053932U" className="md:w-auto md:min-w-[300px] text-lg shadow-xl shadow-terracotta/30" data-id="element-175">
                Lo Necesito Ya! · USD 6,39
              </Button>
              <p className="mt-4 text-sm text-gray-500 flex items-center justify-center" data-id="element-176">
                <Shield className="w-4 h-4 mr-2 text-sage" data-id="element-177" />
                Garantía incondicional de 30 días. Pago 100% seguro.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}